import React from "react";
import { Link } from "react-router-dom";
import { categoryStyle } from "../../../utils/category";
import { cropCenter } from "../../../utils/image";
import "./BlogCard.css";

const BlogCard = ({ blog }) => {
  const formattedDate = new Date(blog.date).toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const authorName = blog.author || "Lingify";

  return (
    <Link to={`/blog/${blog.slug}`} className="blog-card-link">
      <article className="blog-card">
        <div className="blog-card-media">
          <img src={blog.image} alt={blog.title} loading="lazy" style={{ objectPosition: cropCenter(blog.imageCrop) }} />
          <span className="blog-card-badge" style={categoryStyle(blog.category)}>
            {blog.category}
          </span>
        </div>
        <div className="blog-info">
          <h3 title={blog.title}>{blog.title}</h3>
          {blog.summary && <p className="blog-summary">{blog.summary}</p>}
          <div className="blog-card-author">
            <span className="blog-avatar">
              <img src="/shortlogoAphasiAI.svg" alt="Lingify" />
            </span>
            <div className="blog-card-author-info">
              <span className="blog-card-author-name">{authorName}</span>
              <span className="blog-card-author-date">{formattedDate}</span>
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
